import {
    SCROLL_TO_TOP,
    SCROLL_TO_ERRORS,
    SET_CURRENT_PAGE
} from './SkeletonPageConstants';

import { easeInOutSine } from '../../../GB/components/AgreementCheckbox/AgreementCheckboxUtils';
import _ from 'lodash';

export const scrollToError = (errors) => {
    scrollAndFocusToFirstError(window, 500, errors);
    return {
        type: SCROLL_TO_ERRORS,
        payload: true
    };
};

export const scrollToTop = (smooth = true) => {
    if (smooth) {
        smoothScrollTo(window, 500, 0);
    } else {
        window && window.scrollTo(0, 0);
    }

    return {
        type: SCROLL_TO_TOP
    };
};

export const setCurrentPage = (viewName) => {
    return {
        type: SET_CURRENT_PAGE,
        payload: viewName
    };
};

/**
 * Creates a scrollTo animation at call time, then executes it.
 * NOTE: if the height of the page changes while the animation is
 * running, then the user might not get to the bottom of the page
 * (since y positions are calculated at call-time).
 * @param {object} win - The global window object
 * @param {number} duration - the duration of the animation (in milliseconds)
 * @param {number} frameTime - the duration of a frame (in milliseconds)
 */
export const scrollAndFocusToFirstError = (win, duration, firstElementWithError, frameTime = 15) => {
    if (!firstElementWithError) {
        //handleSubmitFail was invoked for reasons other than validation errors
        return;
    }
    // need setTimeout() to focus in chrome.
    setTimeout(function() {
        firstElementWithError.focus();
    }, 100);
    const end = calculateScrollOffset(firstElementWithError, -150);
    smoothScrollTo(win, duration, end, frameTime);
};

export const calculateScrollOffset = (element, offset = 0) => {
    const elementRect = element.getBoundingClientRect();
    const scrollPosition = elementRect.top;
    const scrollOffsetTarget = scrollPosition + offset + window.pageYOffset;
    return scrollOffsetTarget;
};

export const smoothScrollTo = (win, duration, targetY, frameTime = 15) => {
    const start = _.get(win, 'scrollY');
    const end = targetY;
    const steps = [];
    const runAnimation = () => {
        if (steps.length) {
            const shift = steps.shift();
            const lgb = steps.length;
            win.scrollTo(0, shift);
            setTimeout(runAnimation, frameTime);
        }
    };
    if (typeof start === 'number' && typeof end === 'number') {
        const diff = (end - start);
        let curr = 0;
        // build steps
        for (let time = 0; time <= duration; time += frameTime) {
            curr = easeInOutSine(time, start, diff, duration);
            steps.push(curr);
        }
        // ensure we get to the bottom
        if (curr < end) {
            steps.push(end);
        }
        // kick off animation
        runAnimation();
    }
};
